import * as React from "react";
import { InGameMessage } from "./TickerDisplay.actions";

interface ITickerContent {
  message: string | InGameMessage[];
}

export class TickerContent extends React.PureComponent<ITickerContent> {
  public render() {
    const { message } = this.props;

    if (typeof message === "string") {
      return <>{message}</>;
    } else if (Array.isArray(message)) {
      return (
        <>
          {message.map(({ text, url }, index) => {
            if (!url) {
              return text;
            }

            return (
              <a key={index} href={url} target="_blank">
                {text}
              </a>
            );
          })}
        </>
      );
    }

    return null;
  }
}
